/**
 *
 * Handle actions for the single global FullScreen Tooltip pertaining to having
 * the tooltip content located at the bottom of the <body> tag, thus having a
 * z-index above everything else regardless of multiple stacking contexts on
 * the page.
 *
 * Usage Example:
 *
 * Dust:
 * 	{>"widgets/fullScreenTooltip"
 * 		id="td_gspViewBuyerAddress"
 * 		name="gspViewBuyerAddress"
 * 		title=""
 *		noQuestionIcon="true"
 * 		contentPartial="activity/inc/transactionDetailsTooltip" /}
 *
 * JavaScript:
 *		// 1. sets the content element on the tooltip object and shows the tooltip
 * 		tooltip.showContentFromSelector('#td_gspViewBuyerAddress');
 *
 * 		// 2. Pass backbone view which has content body
 * 		tooltip.showContentFromSelector('#td_gspViewBuyerAddress', myView);
 *
 * Dust:
 * 	<a href="#padTermsAndConditionModule" class="js_padTermsAndConditionModule" data-tooltipid="#padTermsAndConditionModule">
 * 		Terms
 *	</a>
 *	{>"widgets/fullScreenTooltip"
 *		id="padTermsAndConditionModule"
 *		name="padTermsAndConditionModule"
 *		title="{@pre type="content" key="msg.useTerms" editable="false"/}"
 *		contentPartial="wallet/inc/padPolicy"
 *		noQuestionIcon="true" /}
 *
 * Javascript:
 *		// Trigger a hidden fullScreenTooltip with a link,
 *		// Allows the fullScreenTooltip widget to be included anywhere on
 * 		// the page, separate from the link that activates it, and avoids
 * 		// breaking markup.
 * 		'click .js_padTermsAndConditionModule': tooltip.triggerFullScreenTooltip
 *
 */

define(['jquery'], function ($) {
	'use strict';

	var $globalContainer = $('#fullscreentooltip');

	var showContentFromSelector = function showContentFromSelector (selector, view) {
		var $newContent,
			$contentBody;

		if (!selector) {
			return;
		}

		// create a deep copy of the set of the selector's matched elements
		// remove the ID attribute from the cloned copy because IDs are supposed to be unique
		$newContent = $(selector).clone().removeAttr('id');

		if (view) {
			$contentBody = $newContent.find('.body');
			$contentBody.html(view.$el);

			// Toggle `modal` after rendering is done.
			// Otherwise bootstrap cannot render `modal-backdrop` correctly
			view.afterRender = function() {
				$globalContainer.html($newContent).
					children('.modal').modal('show');
			};
		} else {
			// set the HTML contents of the global container
			// use Bootstrap Modal API to show the tooltip
			$globalContainer.html($newContent).
				children('.modal').modal('show');
		}
	};

	var triggerFullScreenTooltip = function triggerFullScreenTooltip (event) {
		var elData = $(event.target).data(),
			tooltipContentSelector = elData && elData.tooltipid;

		event.preventDefault();

		if (tooltipContentSelector) {
			// sets the content element on the tooltip object and shows the tooltip
			showContentFromSelector(tooltipContentSelector);
		}
	};

	return {

		/**
		 * @param selector {string} - selector string of the content (tooltip widget)
		 * @param view {Backbone.View} - Backbone view which has tooltip body (optional)
		 *
		 * Clones the content into the global container and uses the Bootstrap
		 * Modal API to show the tooltip
		 */
		showContentFromSelector: showContentFromSelector,

		/*
		 * Trigger a hidden fullScreenTooltip with a link
		 *
		 * The link requires a data-tooltipid attribute that selects the
		 * fullScreenTooltip widget.
		 *
		 * This allows the fullScreenTooltip widget to be included anywhere on
		 * the page, separate from the link that activates it, and avoids
		 * breaking markup.
		 */
		triggerFullScreenTooltip: triggerFullScreenTooltip
	};
});



//////////////////
// WEBPACK FOOTER
// ./widgets/thetooltip.js
// module id = 423
// module chunks = 0